import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, Input, Label } from '@mono/ui-components';
import { useEffect, useState } from 'react';
/**
 * PromptDialog replaces `window.prompt()`. Used for folder name + rename flows.
 * Resets its internal value whenever it's re-opened.
 */ export function PromptDialog({ open, onOpenChange, title, description, label, placeholder, initialValue = '', confirmLabel = 'Create', onConfirm }) {
    const [value, setValue] = useState(initialValue);
    const [submitting, setSubmitting] = useState(false);
    useEffect(()=>{
        if (open) setValue(initialValue);
    }, [
        open,
        initialValue
    ]);
    async function handleSubmit(e) {
        e.preventDefault();
        const trimmed = value.trim();
        if (!trimmed) return;
        setSubmitting(true);
        try {
            await onConfirm(trimmed);
            onOpenChange(false);
        } finally{
            setSubmitting(false);
        }
    }
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ _jsx(DialogContent, {
            children: /*#__PURE__*/ _jsxs("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ _jsxs(DialogHeader, {
                        children: [
                            /*#__PURE__*/ _jsx(DialogTitle, {
                                children: title
                            }),
                            description && /*#__PURE__*/ _jsx(DialogDescription, {
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "grid gap-2 py-4",
                        children: [
                            /*#__PURE__*/ _jsx(Label, {
                                htmlFor: "prompt-input",
                                children: label
                            }),
                            /*#__PURE__*/ _jsx(Input, {
                                id: "prompt-input",
                                autoFocus: true,
                                value: value,
                                placeholder: placeholder,
                                onChange: (e)=>setValue(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(DialogFooter, {
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                variant: "outline",
                                onClick: ()=>onOpenChange(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "submit",
                                disabled: submitting || !value.trim(),
                                children: submitting ? 'Saving…' : confirmLabel
                            })
                        ]
                    })
                ]
            })
        })
    });
}
